export default __webpack_public_path__ + "static/media/arras19.3460a5f8.jpg";